module.exports = __webpack_public_path__ + "static/media/jumbo3.8fdec4a4.png";